import React, { useEffect, useState, useCallback } from "react";
import { Row, Col } from "react-bootstrap";
import Card from "../../../components/Card";
import { handleApiError } from "../../../js/helper/errorHandler";
import DataTable from "../components/DataTable/DataTable";
import { useTable } from "../components/DataTable/useTable";
import { LogsAPI } from "../../../js/api";

const Logs = () => {
  const { page, limit, search, setPage, setLimit, setSearch } = useTable({});
  const [logs, setLogs] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(false);

  const columns = [
    { key: "date", label: "Date" },
    { key: "gold", label: "Gold Used" },
    { key: "old", label: "Old Price" },
    { key: "new", label: "New Price" },
    { key: "change", label: "Change" },
    { key: "status", label: "Status" },
    { key: "error", label: "Error" },
  ];

  const fetchLogs = useCallback(async () => {
    try {
      setLoading(true);

      const res = await LogsAPI.getLogs(page, limit, search);

      if (res.data.status === 200) {
        setLogs(res.data.data.logs);
        setPagination(res.data.data.pagination);
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  }, [page, limit, search]);

  useEffect(() => {
    fetchLogs();
  }, [fetchLogs]);

  return (
    <Row>
      <Col sm="12">
        <Card>
          <Card.Body>
            <h4 className="mb-3">Price Update Logs</h4>
            <Row className="mb-3">
              <Col md={4}>
                <Card className="text-center p-3">
                  <h6>Updated</h6>
                  <h4>
                    {
                      logs.filter((l) => l.change_reason === "price_update")
                        .length
                    }
                  </h4>
                </Card>
              </Col>

              <Col md={4}>
                <Card className="text-center p-3">
                  <h6>Skipped</h6>
                  <h4>
                    {
                      logs.filter(
                        (l) => l.change_reason === "skipped_low_change",
                      ).length
                    }
                  </h4>
                </Card>
              </Col>

              <Col md={4}>
                <Card className="text-center p-3">
                  <h6>Errors</h6>
                  <h4>
                    {logs.filter((l) => l.change_reason === "error").length}
                  </h4>
                </Card>
              </Col>
            </Row>

            <DataTable
              columns={columns}
              data={logs}
              loading={loading}
              search={search}
              onSearch={setSearch}
              page={page}
              totalPages={pagination?.totalPages || 1}
              limit={limit}
              onLimitChange={setLimit}
              onPageChange={(p) => setPage(p)}
              renderRow={(log) => (
                <tr key={log._id}>
                  <td>{new Date(log.createdAt).toLocaleString()}</td>

                  <td>
                    {log.gold_price_used !== null
                      ? `₹${log.gold_price_used}`
                      : "-"}
                  </td>

                  <td>{log.old_price !== null ? `₹${log.old_price}` : "-"}</td>

                  <td>{log.new_price !== null ? `₹${log.new_price}` : "-"}</td>
                  <td>
                    {log.old_price && log.new_price
                      ? `₹${(log.new_price - log.old_price).toFixed(2)}`
                      : "-"}
                  </td>

                  <td>
                    {log.change_reason === "price_update" && (
                      <span className="badge bg-success">Updated</span>
                    )}
                    {log.change_reason === "skipped_low_change" && (
                      <span className="badge bg-secondary">Skipped</span>
                    )}
                    {log.change_reason === "error" && (
                      <span className="badge bg-danger">Error</span>
                    )}
                  </td>

                  <td style={{ maxWidth: 200 }}>{log.error_message || "-"}</td>
                </tr>
              )}
            />
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default Logs;
